import React, { useState } from 'react';

const EnquiryForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: 'I am interested in this vehicle. Please contact me with more information.',
    preferredContact: 'phone',
    partExchange: false
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you for your enquiry! We will contact you within 24 hours.');
  };

  return (
    <div className="enquiry-form-container">
      <h3>Make an Enquiry</h3>
      <form onSubmit={handleSubmit} className="enquiry-form">
        <div className="form-row">
          <div className="form-group">
            <label>Full Name *</label>
            <input 
              type="text" 
              required
              placeholder="John Smith"
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
            />
          </div>
          <div className="form-group">
            <label>Email Address *</label>
            <input 
              type="email" 
              required
              placeholder="john@example.com"
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
            />
          </div>
        </div>
        
        <div className="form-group">
          <label>Phone Number *</label>
          <input 
            type="tel" 
            required
            placeholder="07123 456789"
            value={formData.phone}
            onChange={(e) => setFormData({...formData, phone: e.target.value})}
          />
        </div>

        <div className="form-group">
          <label>Preferred Contact Method</label>
          <div className="radio-group">
            {['phone', 'email', 'sms'].map(method => (
              <label key={method} className="radio-label">
                <input 
                  type="radio" 
                  name="contact"
                  checked={formData.preferredContact === method}
                  onChange={() => setFormData({...formData, preferredContact: method})}
                />
                {method.charAt(0).toUpperCase() + method.slice(1)}
              </label>
            ))}
          </div>
        </div>

        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input 
              type="checkbox"
              checked={formData.partExchange}
              onChange={(e) => setFormData({...formData, partExchange: e.target.checked})}
            />
            I have a part exchange vehicle
          </label>
        </div>

        <div className="form-group">
          <label>Message</label>
          <textarea 
            rows="4"
            value={formData.message}
            onChange={(e) => setFormData({...formData, message: e.target.value})}
          />
        </div>

        <button type="submit" className="btn btn-primary full-width">
          Send Enquiry
        </button>
        <p className="privacy-note">By submitting, you agree to our Privacy Policy</p>
      </form>
    </div>
  );
};

export default EnquiryForm;
